<template>
  <div>
    <el-card shadow="hover"
             style="margin-bottom: 10px"
             v-show="isClearValivitor">
      <h3>基础信息</h3>
      <div class="warp">
        <page-form :ref-obj.sync="formInfo.ref"
                   permission="goodsManageAdd"
                   :data="formInfo.data"
                   :fileList="formFieldList"
                   :labelWidth="formInfo.labelWidth"
                   :ruleList="formInfo.rules"
                   :submit="submitConfig">
          <template v-slot:form-box>
            <el-input v-model="formInfo.data.box"
                      placeholder="请输入"
                      maxlength="10">
              <template slot="append">件/箱</template>
            </el-input>
          </template>
          <template v-slot:form-boxWide>
            <el-input v-model="formInfo.data.boxWide"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^0-9.]/g,'')">
              <template slot="append">cm</template>
            </el-input>
          </template>
        </page-form>
        <page-form :ref-obj.sync="formInfo2.ref"
                   permission="goodsManageAdd"
                   :data="formInfo2.data"
                   :fileList="formFieldList2"
                   :labelWidth="formInfo2.labelWidth"
                   :ruleList="formInfo2.rules"
                   :submit="submitConfig">
          <template v-slot:form-boxLong>
            <el-input v-model="formInfo2.data.boxLong"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^0-9.]/g,'')">
              <template slot="append">cm</template>
            </el-input>
          </template>
          <template v-slot:form-boxHigh>
            <el-input v-model="formInfo2.data.boxHigh"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^0-9.]/g,'')">
              <template slot="append">cm</template>
            </el-input>
          </template>
          <template v-slot:form-weight>
            <el-input v-model="formInfo2.data.weight"
                      placeholder="请输入"
                      maxlength="10"
                      oninput="value=value.replace(/[^\d.]/g,'')">
              <template slot="append">KG</template>
            </el-input>
          </template>
          <template v-slot:form-standardCode>
            <el-input v-model="formInfo2.data.standardCode"
                      placeholder="请输入(取值1-9999)"
                      maxlength="4"
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')">
              <template slot="append">箱/板</template>
            </el-input>
          </template>
          <template v-slot:form-expDays>
            <el-input v-model="formInfo2.data.expDays"
                      placeholder="请输入"
                      maxlength="4"
                      oninput="value=value.replace(/[^\d]|^[0]/g,'')">
              <template slot="append">天</template>
            </el-input>
          </template>
          <template v-slot:form-salePrice>
            <el-input v-model="formInfo2.data.salePrice"
                      placeholder="请输入"
                      maxlength="9">
              <template slot="append">元/件</template>
            </el-input>
          </template>
          <template v-slot:form-supplierCode>
            <el-select v-model="formInfo2.data.supplierCode" placeholder="请选择" clearable @change="getIsAcc">
              <el-option v-for="(item,index) in supplierSelect" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </template>
        </page-form>
      </div>
      <div class="goodsImg">
        <uploadImg ref="uploadImg" :list='formInfo.data.url'></uploadImg>
      </div>
    </el-card>
    <el-card shadow="hover" v-if="isAcc != 1">
      <h3>费用配置</h3>
      <div class="wrap"
           style="padding: 20px 0 0">
        <!-- 列表 S -->
        <page-table :list="goodsList"
                    :fieldList="fieldList"
                    deleteName="id">
          <template v-slot:col-num1="scope">
            <el-input style="width: 75px!important"
                      type="number"
                      v-model="scope.row.num1"
                      :oninput="`if(value<0){value=0}else{value=parseInt(value)}`"></el-input>箱
          </template>
          <template v-slot:col-ceshi2="scope">
            <el-select v-model="scope.row.ceshi2"
                       placeholder="请选择"
                       clearable>
              <el-option label="箱"
                         value="1"></el-option>
              <el-option label="重量/体积"
                         value="2"></el-option>
            </el-select>
          </template>
          <template v-slot:col-ceshi3="scope">
            <span v-if="scope.row">{{changeCeshi3}}</span>
          </template>
          <template v-slot:col-ceshi4="scope">
            <el-input :disabled="changeCeshi3 == '-'"
                      v-model="scope.row.ceshi4"
                      @blur='numChange($event,scope.row)'></el-input>
          </template>
          <template v-slot:col-ceshi5="scope">
            <costConfig :type="scope.row.ceshi2" :formInfos='goodsList.rows[0]' @update="update"></costConfig>
          </template>
        </page-table>
        <!-- 列表 E -->
        <div style="display:flex">
          <label style="color: #696969;">备注：费用不填时，默认按供应商或仓库费用配置计费</label>
        </div>
      </div>
    </el-card>

    <el-row type="flex"
            justify="end"
            class="page-component"
            :gutter="12">
      <el-col :span="2">
        <el-button type="primary"
                   @click="submitConfig">保存</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import pageForm from '@/components/Form/Index'
import pageTable from '@/components/Table/Index'
import costConfig from './components/costConfig'
import goodsManage from '@/store/goodsManage/index.js'
import { GOODSADD, GETISACC } from '@/store/goodsManage/types.js'
import uploadImg from './components/uploadImage'
import mixin from './components/mixin'
import user from '@/store/user/index'

export default {
  name: 'goodsadd',
  data () {
    return {
      warehouseCode: ''
    }
  },
  components: {
    pageForm,
    pageTable,
    uploadImg,
    costConfig
  },
  watch: {
  },
  computed: {
    // 用户信息
    userInfo () {
      return user.state.userinfo
    },
    // 表单验证
    formFieldList2 () {
      let a = [
        { label: '供应商', prop: 'supplierCode', type: 'slot', required: true },
        { label: '规格', prop: 'standard', type: 'input', min: 0, max: 15 },
        { label: '外箱长', prop: 'boxLong', type: 'slot', required: true, validator: this.validateBoxLong },
        { label: '外箱高', prop: 'boxHigh', type: 'slot', required: true, append: 'cm', validator: this.validateBoxHigh },
        { label: '外箱毛重', prop: 'weight', type: 'slot', required: true, append: 'KG', validator: this.validateWeight },
        { label: '标准码放数', prop: 'standardCode', type: 'slot', required: true, append: 'KG', validator: this.validateformatNum },
        { label: '销售价', prop: 'salePrice', type: 'slot', required: true, append: '元/件', validator: this.validateformatprice }
      ]
      if (this.userInfo.isMdOpen === 1) {
        return [...a, { label: '保质期', prop: 'expDays', type: 'slot', required: false, append: '天' }]
      } else {
        return a
      }
    },
    // 计算体积
    allTotal () {
      let { boxWide } = this.formInfo.data
      let { boxHigh, boxLong } = this.formInfo2.data
      if (isNaN(parseFloat(boxWide)) || isNaN(parseFloat(boxHigh)) || isNaN(parseFloat(boxLong))) {
        return ''
      }
      let width = Math.floor(boxWide * 100) / 100
      let height = Math.floor(boxHigh * 100) / 100
      let long = Math.floor(boxLong * 100) / 100
      return width * height * long
    },
    costMask () {
      return goodsManage.state.costMask
    },
    // 是否为"累加"，为1则不显示费用配置
    isAcc () {
      return goodsManage.state.isAcc
    }

  },
  mounted () {
    this.warehouseCode = this.$route.params.warehouseCode
  },
  methods: {
    // 保存
    submitConfig () {
      // console.log(this.formInfo.data.box, 'this.formInfo.data.box')
      let flag1 = false
      this.formInfo.ref.validate((valid) => {
        if (valid) {
          flag1 = true
        } else {
          flag1 = false
        }
      })
      let flag2 = true
      this.formInfo2.ref.validate((valid) => {
        if (valid) {
          flag2 = true
        } else {
          flag2 = false
        }
      })
      if (this.formInfo.data.name === '') {
        flag1 = false
      }
      if (flag1 && flag2) {
        this.$confirm('商品长宽高等信息将影响费用计算，请正确填写。您确定现在保存吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let {rows} = this.goodsList
          let params = {
            ...this.formInfo.data,
            ...this.formInfo2.data,
            computeType: rows[0].ceshi3,
            price: rows[0].ceshi4 ? parseFloat(rows[0].ceshi4).toFixed(2) : null,
            smallestRule: JSON.stringify(rows[0].smallestRule),
            smallestUnit: rows[0].smallestUnit,
            warehouseCode: this.warehouseCode
          }
          params.url = this.$refs.uploadImg.getFileList()
          // 为累加则不传参数
          if (this.isAcc === 1) {
            params.computeType = undefined
            params.price = undefined
            params.smallestRule = undefined
            params.smallestUnit = undefined
          }
          this.$store.dispatch(GOODSADD, params)
        })
      }
    },
    numChange (e, data) {
      data.ceshi4 = parseFloat(data.ceshi4).toFixed(2)
    },
    validateformatNum (rule, value, callback) {
      if (!value) {
        callback(new Error('请输入'))
      }
      callback()
    },
    validateformatprice (rule, value, callback) {
      var reg3 = /^(0|([1-9][0-9]*))+(\.[0-9]{1,2})?$/
      if (!value) {
        callback(new Error('请输入销售价'))
      }
      if (Number(value) <= 0 || Number(value) >= 1000000) {
        callback(new Error('销售价需大于0且小于1000000'))
      }
      if (!reg3.test(value)) {
        callback(new Error('只能保留两位小数'))
      }
    },
    validateNum (rule, value, callback, name) {
      if (!value) {
        callback(new Error('请输入'))
      } else if (value.split('.').length > 2) {
        // 防止输入多个小数点
        callback(new Error('请输入正确的格式'))
      } else {
        // 四舍五入
        value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)
        // 不足补位
        value = Number(value).toFixed(2)
        if (name === 'boxWide') {
          this.formInfo.data[name] = value
        } else {
          this.formInfo2.data[name] = value
        }
        callback()
      }
    },

    valformatNum (rule, value, callback, name) {
      // 四舍五入
      value = Math.round(value * Math.pow(10, 2)) / Math.pow(10, 2)
      // 不足补位
      // value = Number(value).toFixed(2)
      if (name === 'standardCode') {
        this.formInfo2.data[name] = value
      } else {
        this.formInfo2.data[name] = value
      }
      callback()
    },
    // 新增、编辑时查询是否为"累加"，是则不显示费用配置
    getIsAcc () {
      let params = {
        supplierCode: this.formInfo2.data.supplierCode
      }
      this.$store.dispatch(GETISACC, params)
    }

  },
  mixins: [mixin]
}
</script>

<style scoped>
.warp,
.goodsImg {
  display: flex;
  padding: 20px 50px 0;
}
.warp >>> .el-form:last-child {
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/page/goodsManage/GoodsAdd.vue